/**
 * user
 * @author wwl
 * @created 2024/10/11
 * @modified 2024/10/11
 */
import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => ({
    origins: '', // 来源页面
    action: 0, // 来源接口   1:展位预订  2:门票预订  3:展商名录  4:开展提醒
    industryId: 0, // 展会行业
    bdUrl: ''
  }),
  actions: {
    setOrigins(data: any) {
      this.origins = data
    },
    setAction(data: any) {
      this.action = data
    },
    setIndustryId(data: any) {
      this.industryId = data
    },
    setBDurl(data: any) {
      this.bdUrl = data
    }
  }
})
